export const FETCH_SET_GLOBAL_TEMPLATE_NAME_REQUEST = 'FETCH_SET_GLOBAL_TEMPLATE_NAME_REQUEST'
export const FETCH_SET_GLOBAL_TEMPLATE_NAME_SUCCESS = 'FETCH_SET_GLOBAL_TEMPLATE_NAME_SUCCESS'
export const FETCH_SET_GLOBAL_TEMPLATE_NAME_FALUIRE = 'FETCH_SET_GLOBAL_TEMPLATE_NAME_FALUIRE'
